module.exports = __webpack_public_path__ + "img/slide-17_medium.150fe184.png";